
var HasPermissions = function (action, userPermissions) {

	if (userPermissions === undefined || userPermissions.length === 0) return false;

	if (action === "")
		return true;
	var hasPermissionForAction = userPermissions.some((permission) => permission.toLowerCase() === action.toLowerCase());
	return hasPermissionForAction;
}

export { HasPermissions };



// WEBPACK FOOTER //
// ./src/components/HasPermissions.js